import { FixMeLater } from '../../temporary-types';
import ACTIONS_TYPES from '../../constants/types';
import BASE_PATH from '../../constants/path';
import { EnvService } from '../../environments/environmentsService';
import {
  DEFAULT_PORTAL_LANGUAGE,
  DEFAULT_PORTAL_LANGUAGES,
} from '../../constants/common';

export type ILanguageTranslation = Dict<string>;

interface IIntro {
  title: ILanguageTranslation;
  introductionText: ILanguageTranslation;
}

interface IFooterLink {
  label: ILanguageTranslation;
  url: ILanguageTranslation;
  code: string;
  disabled: boolean;
}

interface IFooter {
  copyrightText: ILanguageTranslation;
  links: IFooterLink[];
}

interface IHeader {
  pageTitle: ILanguageTranslation;
  faviconUrl: string;
  topHeaderText: string;
  logoUrl: string;
  logoHeaderText: ILanguageTranslation;
}

interface ISubmitResultScreen {
  code: string;
  title: ILanguageTranslation;
  description: ILanguageTranslation;
  editButtonVisible: boolean;
}

export interface ISubmitConfig {
  showSummary: boolean;
  stepSubmitOn: boolean;
  summaryText: ILanguageTranslation;
}

export interface GlobalConfigState {
  accentColor: string | null;
  backgroundImage: string | null;
  primaryColor: string | null;
  primaryTextColor: string | null;
  secondaryTextColor: string | null;
  intro: IIntro | null;
  footer: IFooter | null;
  header: IHeader | null;
  languages: string[] | null;
  defaultLanguage: string | null;
  defaultCountryPhoneCode: string | null;
  hideLanguagesFlags: boolean;
  showMyAccreditation: boolean | null;
  submitConfig: ISubmitConfig | null;
  projectId: string | null;
  printLayoutId: string | null;
  formType: string | null;
  formDefId: string | null;
  submitResultScreens: ISubmitResultScreen[] | null;
  textsOverwritings: Dict<string> | null;
  quotaExceededMessage: Dict<string> | null;
  summaryPageFieldsFromAccount: string[] | null;
}

const { APP_BG_IMAGE_URL } = EnvService.getInstance();

const initialState: GlobalConfigState = {
  accentColor: '#0057b7',
  backgroundImage: APP_BG_IMAGE_URL
    ? APP_BG_IMAGE_URL
    : `${BASE_PATH}assets/UEFA_EURO2024_REGISTRIERUNG_HG.jpg`, // Reference the image from the public folder
  primaryColor: '#0057b7',
  primaryTextColor: '#000000',
  secondaryTextColor: '#000000',
  intro: null,
  footer: null,
  header: null,
  languages: DEFAULT_PORTAL_LANGUAGES,
  defaultLanguage: DEFAULT_PORTAL_LANGUAGE,
  defaultCountryPhoneCode: null,
  hideLanguagesFlags: false,
  showMyAccreditation: null,
  submitConfig: null,
  projectId: null,
  printLayoutId: null,
  formType: null,
  formDefId: null,
  submitResultScreens: null,
  textsOverwritings: null,
  quotaExceededMessage: null,
  summaryPageFieldsFromAccount: [],
};

export default function (state = initialState, action: FixMeLater) {
  switch (action.type) {
    case ACTIONS_TYPES.SET_GLOBAL_CONFIG:
      return { ...state, ...action.payload };

    case ACTIONS_TYPES.SET_GLOBAL_DEFAULT_LANGUAGE:
      return { ...state, defaultLanguage: action.payload };

    case ACTIONS_TYPES.SET_GLOBAL_LANGUAGES:
      return { ...state, languages: action.payload };

    case ACTIONS_TYPES.SET_PREVIEW_FORM:
      return {
        ...state,
        submitConfig: {
          showSummary: state.submitConfig?.showSummary,
          stepSubmitOn: false,
          summaryText: state.submitConfig?.summaryText ?? null,
        },
      };

    default:
      return state;
  }
}
